'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Scenario = function () {

  /**
   *
   * @param {string} apply - one of 'IN' or 'EXCEPT'
   * @param {Array<string>} scenarios
   * @param {Validator|function|array|boolean} validator - rule description (see Model.rules)
   */


  /**
   * Rule description
   * @type {Validator|function|array|boolean}
   */


  /**
   * Determines when to apply or not the validator
   * @type {string}
   */
  function Scenario(apply, scenarios, validator) {
    _classCallCheck(this, Scenario);

    this.apply = Scenario.APPLY_EXCEPT;
    this.scenarios = [];

    if (!(apply === Scenario.APPLY_EXCEPT || apply === Scenario.APPLY_IN)) {
      throw new Error('Scenario::constructor apply property has invalid value');
    }

    if (!Array.isArray(scenarios)) {
      throw new Error('Scenario::constructor scenarios property must be an array');
    }

    this.apply = apply;
    this.scenarios = scenarios;
    this.validator = validator;
  }

  /**
   * Fast creating of a Scenario instance with the Scenario.APPLY_IN behavior
   * @param {Array<string>} scenarios
   * @param {Validator|function|array|boolean} validator - rule description (see Model.rules)
   * @returns {Scenario}
   */


  /**
   * A list of scenarios for which provided validator will be applied or not (see apply property)
   * @type {Array}
   */


  _createClass(Scenario, null, [{
    key: 'in',
    value: function _in(scenarios, validator) {
      return new Scenario(Scenario.APPLY_IN, scenarios, validator);
    }

    /**
     * Fast creating of a Scenario instance with the Scenario.APPLY_EXCEPT behavior
     * @param {Array<string>} scenarios
     * @param {Validator|function|array|boolean} validator - rule description (see Model.rules)
     * @returns {Scenario}
     */

  }, {
    key: 'except',
    value: function except(scenarios, validator) {
      return new Scenario(Scenario.APPLY_EXCEPT, scenarios, validator);
    }
  }]);

  return Scenario;
}();

Scenario.APPLY_IN = 'IN';
Scenario.APPLY_EXCEPT = 'EXCEPT';
exports.default = Scenario;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/Scenario.js
// module id = 297
// module chunks = 0